<template>
  <div>
    <v-toolbar color="page-toolbar">
      <v-toolbar-title class="text-body-large">Mon abonnement</v-toolbar-title>
    </v-toolbar>

    <v-row>
      <v-col cols="12"></v-col>
      <v-col cols="12" md="8" lg="6">
        <v-card v-if="loading" class="mt-4 ml-2 mr-2" elevation="6">
          <v-skeleton-loader type="heading, paragraph, actions"></v-skeleton-loader>
        </v-card>

        <v-alert v-else-if="errorMessage" type="error" variant="tonal" class="mt-4 ml-2 mr-2">
          {{ errorMessage }}
          <template #append>
            <v-btn variant="text" @click="loadSubscription">Réessayer</v-btn>
          </template>
        </v-alert>

        <subscribed-account
          v-else-if="subscription || isMember"
          :subscription="subscription"
          :membership-end-date="membershipEndDate"
          :is-admin="isAdmin"
        ></subscribed-account>

        <subscription v-else></subscription>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { UserService } from "@/store/modules/user";
  import SubscribedAccount from "@/components/pages/subscription/SubscribedAccount.vue";
  import Subscription from "@/components/pages/subscription/Subscription.vue";

  // Account page of the membership: the Stripe subscription when there is one, the membership without
  // subscription (one-time payment, admin), or the offer for everyone else.
  export default {
    name: "StripePortal",
    components: { SubscribedAccount, Subscription },
    props: {
      isMember: {
        type: Boolean,
        default: false,
      },
      membershipEndDate: {
        type: Number,
        default: null,
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
      isConnected: {
        type: Boolean,
        default: false,
      },
      isAuthResolved: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        loading: true,
        errorMessage: "",
        subscription: null,
      };
    },
    watch: {
      // Waits for the sign-in state: the subscription lookup needs the signed-in user
      isAuthResolved: {
        immediate: true,
        handler(isResolved) {
          if (isResolved) {
            this.loadSubscription();
          }
        },
      },
      isConnected() {
        if (this.isAuthResolved) {
          this.loadSubscription();
        }
      },
    },
    methods: {
      async loadSubscription() {
        this.errorMessage = "";
        if (!this.isConnected) {
          this.subscription = null;
          this.loading = false;
          return;
        }

        this.loading = true;
        try {
          this.subscription = await UserService.actions.fetchCustomerSubscriptions();
        } catch (error) {
          console.error("Unable to load the subscription:", error);
          this.errorMessage = "Impossible de charger votre abonnement pour le moment.";
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
